// extracted by mini-css-extract-plugin
export default {"Delete":"authorizedUserList_Delete__mIR6D"};